

const ROUTES_NAVIGATION = {
  ACTIONTAKENLIST: "/admin/manage-lead/action-taken",
  ACTIONTOBETAKEN: "/admin/manage-lead/action-tobe-taken",
  EDITACTIONTAKEN: "/admin/manage-lead/action-taken/edit-action-taken",
  EDITACTIONTOBETAKEN: "/admin/manage-lead/action-taken/edit-action-to-be-taken",
  ACTIONTOBETAKENLIST: "/admin/manage-lead/action-to-be-taken",
  // /admin/manage-lead/action-taken/add-action-taken
  ADDACTIONTAKEN: "/admin/manage-lead/action-taken/add-action-taken",
  ADDACTIONTOBETAKEN: "/admin/manage-lead/action-to-be-taken/add-action-to-be-taken",
  ADDBUSSINESSPARTNER:
    "admin/manage-dealer/business-partner/add-business-partner",
  ADDBUSINESSPARTNERTYPELIST:
    "admin/manage-dealer/business-partner-type/add-business-partner-type",
  EDITBUSINESPARTNERTYPE: "/admin/manage-dealer/business-partner-type/edit-business-partner-type",
  ADDCUSTOMER: "/admin/manage-onboard/onboard/create-customer",
  ADDDEALER: "/admin/manage-dealer/dealer/add-dealer",

  ENGINEER: "admin/manage-engineer/engineer",
  ADDENGINEER: "/admin/manage-engineer/engineer/add-engineer",
  EDITENGINEER: "/admin/manage-engineer/engineer/edit-engineer",
  SALESPERSON: "admin/manage-sales-person/sales-person",
  ADDSALESPERSON: "/admin/manage-sales-person/sales-person/add-salesperson",
  EDITSALESPERSON: "/admin/manage-sales-person/sales-person/edit-salesperson",

  ORDERDETAILS:"/admin/manage-mis/order-details",
  STOCKDETAILSVEHICLES:"/admin/manage-mis/stock-details",
  SALESSTOCKDETAILSVEHICLES:"/sales/manage-mis/stock-details",

  DAILYSTOCKUPDATE:"/admin/dailyStockUpdate",

  POLICYMASTER: "/sales/policy-master",
  VIEWPROFILEDEALER: "/dealer-edit/view-profile",
  GRACEPERIOD:"sales/manage-warranty/grace-period-list",
  ADDGRACEPERIOD:"/sales/manage-warranty/grace-period-list/add",

  ADMINGRACEPERIOD:"admin/manage-warranty/grace-period-list",
  MISREPORTCLAIM:"admin/manage-mis/warrenty-claim-report",

  ADDDEALERBRANCH:
    "/admin/manage-dealer-branch/dealer-branch/add-dealer-branch",
  EDITDEALERBRANCH: "/admin/manage-dealer-branch/dealer-branch/edit-dealer-branch",
  ADDDEPARTMENT: "admin/manage-dealer/department/add-department",
  EDITDEPARTMENT: "/admin/manage-dealer/department/edit-department",
  ADDDESIGNATION: "admin/manage-designation/designation/add-designation",
  EDITDESIGNATION: "/admin/manage-designation/designation/edit-designation",
  EDITLANGUAGE: "/admin/manage-user/languages/edit-language",
  DEALERLOGINREPORT: 'admin/manage-login-report/delaerlogin-report',
  ADDLANGUAGE: "admin/manage-user/languages/add-language",
  ADDLEADPRIORITY: "/admin/manage-lead/lead-priority/add-lead-priority",
  ADDLEADSOURCE: "/admin/manage-lead/lead-priority/add-lead-source",
  ADDLEADSTATUS: "/admin/manage-lead/lead-status/add-lead-status",
  ADDPRODUCT: "/admin/manage-product/product/add-product",
  EDITPRODUCT: "/admin/manage-product/product/update-product",
  ADDPUBLISHER: "/admin/manage-campaign/publisher/add-publisher",
  EDITPUBLISHER: "/admin/manage-campaign/publisher/edit-publisher",
  ADDNEWAGENT: "/admin/manage-onboard/onboard/create-agent",
  ADDNEWCAMPAIGN: "/admin/manage-campaign/campaign/add-campaign",
  ADDNEWCUSTOMER: "admin/manage-onboard/onboard/create-customer",
  ADDNEWLEAD: "/admin/manage-lead/lead-allocation/add-lead",
  ADDLEAD: "/admin/manage-lead/lead-allocation/add-new-lead",
  ALLOWLEAD: "/admin/manage-lead/lead-allocation/allow-new-lead",
  ADDNEWSOURCE: "/admin/manage-campaign/source/add-source",
  EDITSOURCE: "/admin/manage-campaign/source/edit-source",
  ADDROLE: "/admin/manage-role/role/add-role",
  EDITROLE: "/admin/manage-role/role/edit-role",
  ADDRTO: "/admin/manage-dealer/rto/add-rto",
  EDITRTO: "/admin/manage-dealer/rto/edit-rto",
  ADDSALESCUSTOMER: "/manage-sales/customer/add-customer",
  EDITSALESCUSTOMER: "/manage-sales/customer/edit-customer",
  ADDSUBPRODUCT: "/admin/manage-product/product/add-sub-product",
  EDITSUBPRODUCT: "/admin/manage-product/product/update-subproduct",
  ADDTERM: "admin/manage-termset/termset/add-term",
  EDITTERM: "/admin/manage-termset/termset/edit-term",
  ADD_USER: "admin/manage-user/user/add-user",
  EDIT_USER: "/admin/manage-user/user/edit-user",
  AGENTDETAILS: "/admin/onboard/agent-details",
  BUSSINESSPARTNER: "admin/manage-dealer/business-partner",
  BUSINESSPARTNERTYPELIST: "admin/manage-dealer/business-partnertype",
  CAMPAIGNLIST: "/admin/manage-campaign/campaign",
  CARDDASHBOARD: "/cards/Admin",
  SALESDASHBOARD: "/cards/sales",
  SALESDASHBOARDSALES: "/sales/dashboard",
  CARDDASHBOARDADMIN: "/admin/dashboard",
  SERVICEDASHBOARD: "/cards/services",
  DASHBOARDSERVICE: "/service/dashboard",
  CUSTOMERDETAILS: "/admin/onboard/customer-details",
  DASHBOARD: "/manage-dashboard",
  LOGISTICDASHBOARD: "/cards/logicstics",
  LOGISTICMAINDASHBOARD: "/logistics/dashboard",
  // LOGISTICDASHBOARD:"/logistics/dashboard",
  PRESALEDASHBOARD: "/presale/dashboard",
  CARDDASHBOARDPRESALES: "/cards/pre-sales",
  DEALERBRANCHLIST: "admin/manage-dealer/dealer-branch",
  DEALERLIST: "/admin/manage-dealer/dealer",
  DEPARTMENT: "admin/manage-dealer/department",
  DESIGNATIONLIST: "/admin/manage-user/designation",
  FOLLOWUPREQUIRED: "manage-presale/follow-uprequired",
  STOCKTAKING: "/logistics/manage-stock/physical-stock-taking",
  ADDPHYSICALSTOCKTAKING: "/logistics/manage-stock/add-physical-stock-taking",
  EDITPHYSICALSTOCKTAKING: "/logistics/manage-stock/edit-physical-stock-taking",
  PHYSICALSTOCKTAKINGDETAILS: "/logistics/manage-stock/physical-stock-taking-details",
  ORDERREQUEST: "/logistics/manage-order/order-recieved-request",
  RECEIPTLIST: "/logistics/receipt",
  RECEIPTDETAILS: "/logistics/receipt/receipt-details",
  FOLLOWUPREQUIREDDETAILS: "/manage-presale/follow-uprequired/follow-uprequired-details",
  FOLLOWUPDETAILS: "/manage-presale/today-followup/followup-details",
  LEADCALLING: "manage-presale/lead-calling",
  APPOINTMENTREMINDER: "/manage-presale/appointment-reminder",
  LEADCALLINGDETAILS: "/manage-presale/lead-calling/lead-calling-details",
  BUSINESSPARTNERTYPELIST: "/admin/manage-dealer/business-partner-type",
  ORDERLIST: "/manage-sales/productlist",
  CREATEORDER: "/manage-sales/productlist/create-order",
  MANAGEORDERLIST: "/manage-sales/manage-order",
  MANAGEORDERDETAILS: "/manage-sales/manage-order/order-details",
  GATEPASS: "/manage-sales/get-pass",
  VIEWGATEPASSS: "/manage-sales/details-gatepass",
  SUBSIDYRECONSCILLIATION: "/manage-sales/subsidy-reconciliation",
  ORDERCANCEL: "/manage-sales/order-cancel",
  EDITORDERCANCEL: "",
  VIEWORDERCANCEL: "/manage-sales/order-cancel-details",
  ORDEREXCHANGE: "/manage-sales/order-exchange",
  VIEWORDEREXCHANGE: "/manage-sales/order-exchange-details",
  EXTENDEDWARANTY: "/manage-sales/extended-warranty",
  VIEWEXTENDEDWARRANTY: "/manage-sales/extended-warranty-details",
  EXTENDEDWARANTYAPPROVAL: "/manage-sales/extended-warranty-approval",
  VIEWEXTENDEDWARRANTYAPPROVAL: "/manage-sales/extended-warranty-approval-details",
  ADDQUOTATION: "/manage-sales/add-quotation",
  EDITQUOTATION: "/manage-sales/edit-quotation",
  ADDPROPOSAL: "/manage-sales/add-proposal",
  EDITPROPOSAL: "/manage-sales/edit-proposal",


  SALESEXTENDEDWARRANTY: "/sales/manage-warranty/extend-warranty",
  BATTERYLIST:"/admin/manage-product/battery",
  ADDBATTERY:"/admin/manage-product/battery/add-battery",
  EDITBATTERY:"/admin/manage-product/battery/edit-battery",

  ADMINMISREPORTSALES: "/admin/manage-mis/sales-mis-report",
  SALESMISREPORT: "/sales/manage-mis/sales-mis-report",

  PROPOSALINVOICE: "/manage-sales/proposal-invoice",

  EDITSUBSIDY: "/manage-sales/edit-subsidy",

  ADDCANCELORDER: "/manage-sales/add-cancelorder",
  ADDORDEREXCHANGE: "/manage-sales/add-orderexchange",
  ADDEXTENDEDWARRANTY: "/manage-sales/add-extendedwarranty",
  CUSTOMERDETAILSLIST: "/manage-sales/customer-details",

  VIEWQUOTATIONLIST: "/manage-sales/view-quotation-list",
  VIEWQUOTATIONAPPROVAL: "/manage-sales/view-quotation-approval",
  VIEWPROPOSALLIST: "/manage-sales/view-listlist",
  VIEWPAYMENTRECEIPT: "/manage-sales/view-paymentreceipt",
  VIEWSTOCKALLOTMENT: "/manage-sales/view-stockallotment",
  VIEWDELIVERYDETAILS: "/manage-sales/deliveryorder-details",
  VIEWINVOICE: "/manage-sales/invoice-details",
  VIEWSUBSIDY: "/manage-sales/subsidy-reconciliation-details",
  CUSTOMERPURCHASEORDER: "/sales/manage-customer-purchase-order/purchase-order",
  CUSTOMERPURCHASEORDERSIDEBAR:"/sales/manage-customer-purchase-order",
  ADDCUSTOMERPURCHASEORDER: "/sales/manage-customer-purchase-order/add-purchase-order",
  ADMINCUSTOMERPURCHASEORDER: "/admin/manage-order/customer-purchase-order",
  SALESWARRANTYCHECK: "/sales/manage-warranty/check-warranty",
  SALESWARRANTYCHECKDETAILS: "/sales/manage-warranty/check-warranty/details",
  DEALERSALESREPORT: "/sales/manage-mis/sales-report",
  DEALERWARRANTYREPORT: "/sales/manage-mis/warranty-report",
  DEALERSTOCKREPORT: "/sales/manage-mis/stock-report",
  JOBCARDREPORT: "/sales/manage-mis/job-card-report",
  RIDERSALESDETAILS: '/sales/manage-mis/rider-sale-report',
  ADMINSALESREPORT: '/admin/manage-mis/sales-report',
  ADMINSTOCKREPORT: '/admin/manage-mis/stock-report',
  ADMINWARRANTYREPORT: '/admin/manage-mis/warranty-report',
  ADMINJOBCARD: '/admin/manage-mis/job-card-report',
  ADMINRIDERSALES: '/admin/manage-mis/rider-sale-report',
  ADMINWARRANTYCHECK: "/admin/manage-warranty/check-warranty",
  ADMINWARRANTYCHECKDETAILS: "/admin/manage-warranty/check-warranty/details",
  LANGUAGELIST: "/admin/manage-user/languages",
  LEADALLOCATIONLIST: "/admin/manage-lead/lead-allocation",
  PRESALELEADALLOCATIONLIST: "/manage-presale/lead-allocation",
  PRESALEADDLEAD: "/manage-presale/lead-allocation/add-new-lead",
  LEADPRIORITYLIST: "/admin/manage-lead/lead-priority",
  EDITLEADPRIORITY: "/admin/manage-lead/lead-priority/edit-lead-priority",
  LEADSOURCELIST: "/admin/manage-lead/lead-source",
  LEADSTATUSLIST: "/admin/manage-lead/lead-status",
  EDITLEADSTATUS: "/admin/manage-lead/edit-lead-status",
  LOGIN: "/login",
  FORGOTPASSWORD: "/forgot-password",
  RESETPASSWORD: "/reset-password",
  ONBOARD: "/admin/manage-onboard/onboard",
  ONBOARDAPPROVAL: "/admin/manage-onboard/onboard-approval",
  OLDLEADCALLING: "manage-presale/old-lead-calling",
  OLDLEADCALLINGDETAILS: "/manage-presale/old-lead-calling/old-lead-calling-details",

  STOCKINSALES:"/sales/manage-product/stock-in",
  ADDSTOCKINSALES:"/sales/manage-product/stock-in/add-stock-in",

  REPAIRREPLACEMEMT:"/manage-services/replacement-and-repair",

  STOCKINADMIN:"/admin/manage-product/stock-in",
  ADDSTOCKINADMIN:"/admin/manage-product/stock-in/add-stock-in",
  ADMINSTOCKINREPORT:"/admin/manage-product/stock-in-report",

  INTRANSIT:"/manage-sales/manage-order/in-transit/order-details",

  MANAGESERVICEORDER:"/admin/manage-service-order",

  PRODUCTLIST: "/admin/manage-product/product",
  MAKELIST: "/admin/manage-product/make",
  MODELLIST: "/admin/manage-product/model",
  PRODUCTFINANCIERLIST: "/admin/manage-product/financer",
  PUBLISHERLIST: "/admin/manage-campaign/publisher",
  ROLELIST: "/admin/manage-user/role",
  RTOLIST: "admin/manage-dealer/rto",
  SALESCUSTOMERLIST: "/manage-sales/customer",
  SALESDELIVERYORDERLIST: "/manage-sales/delivery-order",
  SALESINVOICELIST: "/manage-sales/invoice",
  SALESPAYMENTRECEIPTLIST: "/manage-sales/payment-receipt",
  SALESPROPOSALLIST: "/manage-sales/proposal",
  SALESQUOTATIONLIST: "/manage-sales/quotations",
  SALESQUOTATIONAPPROVALLIST: "/manage-sales/quotation-approval",
  SALESSTOCKALLOTMENTLIST: "/manage-sales/stock-allotment",
  SOURCELIST: "/admin/manage-campaign/source",
  SUBPRODUCTLIST: "/admin/manage-product/sub-product",
  TERMLIST: "/admin/manage-termset/termset",
  TODAYSFOLLOUPS: "manage-presale/today-followup",
  ADVANCESEARCH: "/manage-presale/advance-search",
  USER_LIST: "admin/manage-user/user",

  LEADUPLOAD: "/manage-presale/lead-upload",
  BULKUPLOAD: "/admin/manage-bulk",

  // ONBOARD:'admin/manage-onboard/onboard',
  // ADDCUSTOMER:'admin/manage-onboard/onboard/create-customer',
  // CUSTOMERDETAILS:'admin/onboard/customer-details',
  // BUSSINESSPARTNER:'admin/manage-dealer/business-partner',

  // Logistics Master routes
  TAXESLIST: "/admin/manage-logistic/taxes",
  TAXES_ADD: "/admin/manage-logistic/taxes-add",
  EDITTAXES: "/admin/manage-logistic/taxes-edit",
  HSNCODELIST: "/admin/manage-logistic/hsn-code",
  HSNCODE_ADD: "/admin/manage-logistic/hsn-code-add",
  EDITHSNCODE: "/admin/manage-logistic/hsn-code-edit",
  TAXSETLIST: "/admin/manage-logistic/taxset",
  TAXSETADD: "/admin/manage-logistic/taxset-add",
  UNIT: "/admin/manage-logistic/unit",
  UNITADD: "/admin/manage-logistic/unit-add",
  UNITEDIT: "/admin/manage-logistic/unit-edit",
  SEATINGCAPACITYADD: "/admin/manage-product//seating-capacity-add",
  SEATINGCAPACITYEDIT: "/admin/manage-product/seating-capacity-edit",
  WHEELLIST: "/admin/manage-product/wheels",
  WHEELSADD: "/admin/manage-product/wheels/add-wheels",
  WHEELSEDIT: "/admin/manage-product/wheels/edit-wheels",
  VENDORTYPELIST: "/admin/manage-logistic/vender-type",
  VENDORLIST: "/admin/manage-logistic/vendor-master",
  VENDORADD: "/admin/manage-logistic/add-vendor",
  VENDORTYPEADD: "/admin/manage-logistic/add-vendor-type",
  VENDOREDIT: "/admin/manage-logistic/edit-vendor",
  VENDORTYPEEDIT: "/admin/manage-logistic/edit-vendor-type",
  PAYMENTLISTS: "/admin/manage-logistic/payment-term",
  PAYMENTADDTERMS: "/admin/manage-logistic/add-payment-term",
  PAYMENTTERMSEDIT: "/admin/manage-logistic/edit-payment-term",
  PARTCATEGORYLISTS: "/admin/manage-logistic/part-category",
  ADDPARTCATEGORY: "/admin/manage-logistic/add-part-category",
  EDITPARTCATEGORY: "/admin/manage-logistic/edit-part-category",

  DISCOUNTREPORT:"/admin/manage-mis/discount-report",

  //Notification Management
  NOTIFICATIONLIST: "/admin/manage-notification/notification",
  SETNOTIFICATION: "/admin/manage-notification/notification/set-notification",
  UPDATENOTIFICATION: "/admin/manage-notification/notification/update-notification",

  //Order Management
  ORDERMANAGEMENTLIST: "/admin/manage-order/order",
  ACCEPTORDERDETAILS: "/admin/manage-order/order/accept-order-details",

  GENERATEORDER: "/manage-sales/productlist/generate-order",

  SERVICEMANAGEORDER:"/manage-service/manage-order",
  SERVICEGENERATEORDER:"/manage-service/manage-order/generate-order",

  EDITGENERATEORDER: "/manage-sales/productlist/edit-generate-order",

  //Warranty Management
  WARRANTY: "/admin/manage-warranty/warranty",
  WARRANTYADD: "/admin/manage-warranty/warranty/add-warranty",
  WARRANTYEDIT: "/admin/manage-logistic/edit-warranty",
  EXTENDWARRANTY: "/admin/manage-warranty/extend-warranty",
  EXTENDWARRANTYADD: "/admin/manage-warranty/add-extendwarranty",
  EXTENDWARRANTYEDIT: "/admin/manage-logistic/edit-extendwarranty",
  EXTENDWARRANTYAPPROVAL: "/admin/manage-warranty/extend-warranty-approval",
  INSPECTIONEXTENDEDWARRANTYAPPROVAL: "/admin/manage-warranty/approval-inspection-warranty",
  CLAIMWARRANTY: "/admin/manage-warranty/approval-warranty-claim",
  CLAIMWARRANTYDETAILS: "/admin/manage-warranty/approval-warranty-claim/claim-warranty-details",
  EXTENDWARRANTYAPPROVALDETAILS: "/admin/manage-warranty/extend-warranty-approval-details",
  INSPECTIONEXTENDWARRANTYAPPROVALDETAILS: "/admin/manage-warranty/approval-inspection-warranty/inspection-warranty-details",
  // LOGISTICS
  LOGISTICS: "/manage-logistics/logistics",
  ADDLOGISTICS: "/manage-logistics/add-logistics",
  PURCHASEORDER: "/logistics/manage-order/purchase-order",
  ADDPURCHASEORDER: "/manage-order/add-purchase-order",
  UPDATEPURCHASEORDER: "/manage-order/update-purchase-order",
  PURCHASEORDERDETAILS: "/manage-order/purchase-order-details",
  PARTSPECIFIC: "/manage-order/purchase-order-details/part-specific",
  POAPPROVAL: "/logistics/manage-order/po-approval",
  POAPPROVALDETAILS: "/manage-order/po-approval-details",
  ORDERRECIVEDREQUESTDETAILS: "/manage-order/orderreqrecive-details",
  ADDPOAPPROVAL: "/manage-order/po-approval",
  STOCKDETAILS: "/logistics/manage-stock/stock-details",
  STOCKIN: "/logistics/manage-stock/stock-in",
  STOCKINDETAILS: "/logistics/manage-stock/stock-in/stock-in-details",
  STOCKOUTDETAILS: "/logistics/manage-stock/stock-out/stock-out-details",
  STOCKOUT: "/logistics/manage-stock/stock-out",

  SOLDVEHICLECUSTOMERSTOCKIN:"/sales/manage-product/customer-stock-in",
  ADDSOLDVEHICLESERIALS:"/sales/manage-customer-purchase-order/sold-add-purchase-order",
  ADDVEHICLEDETAILS: "/manage-logistics/add-vehicle-details",
  ADDSPAREPARTS: "/manage-logistics/add-spare-parts",
  ADDACCESSORIES: "/manage-logistics/add-accessories",
  EDITPRODUCTCOLOR: "/admin/manage-product/color/edit-product-color",
  PRODUCTCOLORLIST: "/admin/manage-product/color",
  EDITPRODUCTFINANCIER: "/admin/manage-product/financier/edit-financier",
  EDITPRODUCTFUELTYPE: "/admin/manage-product/fuel-type/eedit-fuel-type",
  EDITMAKE: "/admin/manage-product/make/edit-make",
  EDITMODEL: "/admin/manage-product/model/edit-model",
  EDITVARIANT: "/admin/manage-product/variant/edit-variant",
  EDITITEM: "/admin/manage-product/item/edit-item",
  EDITCAMPAIGN: "/admin/manage-campaign/campaign/edit-campaign",
  EDITDEALER: "/admin/manage-dealer/dealer/edit-dealer",

  PRODUCTITEMCATEGORY: "/admin/manage-product/item-category",
  ADDPRODUCTITEMCATEGORY: "/admin/manage-product/item-category/add-item-category",
  EDITPRODUCTITEMCATEGORY: "/admin/manage-product/item-category/edit-item-category",

  PRODUCTFUELTYPELIST: "/admin/manage-product/fuel-type",

  DISCOUNTLIST: "/admin/manage-product/discount",
  ADDDISCOUNTLIST: "/admin/manage-product/add-discount",
  EDITDISCOUNTLIST: "/admin/manage-product/edit-discount",
  SEATINGCAPACITYLIST: "/admin/manage-product/seat-capacity",

  PURCHESHORDERLIST: "/logistics/manage-order/purchase-order",
  USERPRIVILEDGES: "/admin/manage-user/role/role-priviledges",
  USERLISTPRIVILEDGES: "/admin/manage-user/role/user-priviledges",

  EDITAGENT: "/admin/manage-onboard/onboard/edit-agent",
  EDITCUSTOMERAGENTFORM: "/admin/manage-onboard/onboard/edit-agent-customer",
  // AGENTDETAILS:"/admin/manage-onboard/onboard/agent-details"
  CUSTOMERUPDATIONFORM: "http://localhost:3000/customer-details-updatetion-form/",

  //services
  CHECKWARRANTY: "/manage-services/check-warranty",

  ADDJOBCARD: "/manage-services/check-warranty/add-job-card",
  EDITJOBCARD: "/manage-services/check-warranty/edit-job-card",

  VIEWCUSTOMERPURCHASEORDER: "/sales/manage-customer-purchase-order/purchase-order/view-order",
  EDITCUSTOMERPURCHASEORDER:"/sales/manage-customer-purchase-order/purchase-order/edit-order",

  WARRANTYCLAIMS: "/manage-services/warranty-claims",

  NEWOFFER: "/sales/offer-list",

  WARRANTYCLAIMSDETAILS: "/manage-services/warranty-claims/details",

  EXTENDEDWARRANTYSERVICE: "/manage-services/extended-warranty",
  ADDEXTENDEDWARRANTYSERVICES: "/manage-services/extended-warranty/add-extended-warranty",

  WARRANTYINSPECTION: "/manage-services/warranty-inspection",

  PURCHASEORDERSERVICE: "/manage-services/purchase-order",

  PURCHASEORDERDETAILSSERVICE: "/manage-services/purchase-order/details",

  SURVEY: "/manage-services/job-card/job-card-details/survey",
  TECHNICIANLIST: "manage-services/technician-to-do",
  TECHNICIANDETAILS: "manage-services/technician-to-do/technician-details",
  ADDISSUE: "manage-services/technician-to-do/technician-details/add-issue",
  SUPERVISIONLIST: "manage-services/supervisor-to-do",
  SUPERVISIONDETAILS: "manage-services/supervisor-to-do/supervision-details",
  JOBCARDDETAILS: "/manage-services/check-warranty/job-card-details",
  SUPERVISIONPARTAPPROVAL: "manage-services/supervisor-part-approval",
  SUPERVISIONPARTDETAILS: "manage-services/supervisor-part-approval/supervison-part-details",
  SPAREPARTALLOCATION: "manage-services/spare-part-allocation",
  SPAREPARTALLOCATIONDETAILS: "manage-services/spare-part-allocation/spare-part-Allocation-Details",
  SERVICEGETPASS: "manage-services/service-gate-pass",
  SERVICESGETPASSDETAILS: "manage-services/service-gate-pass/services-get-pass-details",
  JOBCARDINVOICESLIST: "manage-services/job-card-invoice",
  JOBCARDINVOICESDETAILS: "manage-services/job-card-invoice/job-invoice-details",
  ADDJOBCARDISSUE: "manage-services/job-card/job-card-details/add-job-card-issue",
  ADDSUPERVISORISSUE: "manage-services/supervisor-to-do/supervision-details/add-supervisor-issue",
  ADDSUPERVISORPARTAPPROVALISSUE: "manage-services/supervisor-part-approval/supervison-part-details/add-supervisorPartApproval-issue",
  PAYMENTINVOICELIST: 'manage-services/job-card-invoice-payment',
  PAYMENTINVOICEDETAILS: 'manage-services/job-card-invoice-payment/payment-invoice-details',
  SURVEYREPORT: "manage-services/job-card/job-card-details/survey-report",

};

export default ROUTES_NAVIGATION;
